import React from 'react';


const AccountOverview = () => {

  return (
    <>
      <section className='row d-flex w-100 mx-auto mb-3'>
        {/* Left Block  */}
        <div className='col-12 col-xl-8 px-0 pe-xl-3'>
          {/* Div 1 */}
          <div className='bg-light rounded-4 p-3 mb-3 d-flex gap-3 flex-wrap align-items-center justify-content-between'>
            <div>
              <h5 className='mb-0'>Get set up to run ads</h5>
              <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid, laudantium?</span>
            </div>

            <button type="button" className='btn btn-primary rounded-pill px-3'>Continue</button>
          </div>

          {/* Div 2 */}
          <div className='bg-light rounded-4 p-3 mb-3 d-flex align-items-start gap-2'>
            <img src="/images/icons/add-payment-method.svg" style={{ height: '25px' }} alt="add-payment-method" />

            <div className='d-flex flex-column align-items-start'>
              <h5 className='mb-0'>Add Payment Method</h5>

              <span className='mt-1 mb-3'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est, consequuntur! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio iste accusamus molestias tempora, aliquam rem dicta nam excepturi veniam magni. <span className='text-primary'>Learn More...</span></span>

              <button type="button" className='btn btn-primary'>Add Payment Method</button>
            </div>
          </div>

          {/* Div 3 */}
          <div className='bg-light rounded-4 p-3 mb-3 d-flex align-items-start gap-2'>
            <img src="/images/icons/briefcase.svg" className='mt-1' style={{ height: '17px' }} alt="add-payment-method" />

            <div className='d-flex flex-column align-items-start'>
              <h5 className='mb-0'>Pages</h5>

              <span className='mt-1 mb-3'>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est, consequuntur! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio iste accusamus molestias tempora, aliquam rem dicta nam excepturi veniam magni.</span>

              <div className='d-flex gap-3 flex-wrap align-items-center'>
                <div className='bg-primary text-white px-4 py-1 rounded-4'>
                  <h6 className='mb-0 fw-normal'>My Pages</h6>
                  <small className='fw-semibold'>All</small>
                </div>
                
                <div className='bg-secondary-subtle px-4 py-1 rounded-4'>
                  <h6 className='mb-0 fw-normal'>Pending Access Requese</h6>
                  <small className='fw-semibold'>Sent</small>
                </div>

                <div className='bg-secondary-subtle px-4 py-1 rounded-4'>
                  <h6 className='mb-0 fw-normal'>Pending Access Requese</h6>
                  <small className='fw-semibold'>Received</small>
                </div>
              </div>

              <span className='my-3 text-secondary'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Mollitia, delectus!</span>

              <div className='d-flex gap-3 flex-wrap'>
                {
                  Array(5).fill(0).map((value, index) => (
                    <div className='d-flex align-items-center gap-3 bg-white shadow-sm px-3 py-2 rounded-3' key={index}>
                      <img src="/images/profile.png" className='border rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />

                      <div>
                        <h6 className='mb-0'>Bussiness Page {index}</h6>
                        <span className='text-secondary'>Page ID: 123456798{index}</span>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>

        {/* Right Block */}
        <div className='col-12 col-xl-4 px-0'>
          {/* Div 4 */}
          <div className='bg-light rounded-4 p-3 mb-3'>
            <div className='d-flex align-items-start gap-3'>
              <div className='bg-secondary-subtle rounded-circle'>
                <img src="/images/icons/campaign-black.svg" className='p-2' style={{ height: '40px' }} alt="campaign" />
              </div>

              <div>
                <h5 className='mb-0'>Campaigns Status</h5>
                <span>● 4 Active ● 2 Pending</span>
              </div>
            </div>

            <div className='bg-white shadow-sm rounded-3 p-3 d-flex gap-3 align-items-center justify-content-between my-3'>
              <h6 className='mb-0'>Active Campaigns</h6>
              <h6 className='mb-0'>4</h6>
            </div>

            <div className='bg-white shadow-sm rounded-3 p-3 d-flex gap-3 align-items-center justify-content-between mb-3'>
              <h6 className='mb-0'>Pending Campaigns</h6>
              <h6 className='mb-0'>2</h6>
            </div>

            <h6 className='mb-2'>Last 7 day</h6>

            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
              <span className='text-secondary'>Amount spent</span>
              <span className='fw-semibold'>0.00</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-3 mb-2'>
              <span className='text-secondary'>Percente spent in learning phase</span>
              <span className='fw-semibold'>0%</span>
            </div>

            <div className='d-flex align-items-center justify-content-between gap-3'>
              <h6 className='mb-0'>Default landing page</h6>

              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" role="switch" defaultChecked />
              </div>
            </div>
          </div>

          {/* Div 5 */}
          <div className='bg-light rounded-4 p-3'>
            <div className='d-flex align-items-start gap-3'>
              <img src="/images/icons/mail-black.svg" className='mt-1' style={{ height: '20px' }} alt="mail" />

              <h5 className='mb-0'>Page Verification Status</h5>
            </div>
            
            <p className='text-secondary mt-2 mb-3'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut, amet!</p>

            <div className='bg-white shadow-sm rounded-3 p-3 d-flex gap-3 align-items-center justify-content-between mb-3'>
              <h6 className='mb-0'>Complete your page</h6>
              <span className='mb-0 text-primary cursor-pointer'>Continue</span>
            </div>

            <div className='bg-white shadow-sm rounded-3 p-3 d-flex gap-3 align-items-center justify-content-between mb-3'>
              <h6 className='mb-0'>Business Detail</h6>
              <span className='mb-0 text-primary cursor-pointer'>Verify</span>
            </div>

            <div className='bg-white shadow-sm rounded-3 p-3 d-flex gap-3 align-items-center justify-content-between mb-3'>
              <h6 className='mb-0'>Payment Method</h6>
              <span className='mb-0 text-primary cursor-pointer'>Update</span>
            </div>
          </div>
        </div>
      </section> 
    </>
  );
};

export default AccountOverview;